import React, { Component } from 'react'
import { Card, Row, Col, Breadcrumb, Affix, Alert, Icon } from 'antd'
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import logo from '../../icon.png'
import SearchBox from './SearchBox';
import './Banner.css'
import { RootPath } from '../../Settings';

//------------------- Breadcrumb --------------------
/*
const breadcrumbNameMap = {
    '/search': 'Search',
    '/compute': 'Computation',
    '/about': 'About',
    '/news': 'News',
    '/404': 'Page not found',
    '/': 'CASTp'
};
*/
const breadcrumbNameMap = {};
breadcrumbNameMap[RootPath+'search']= 'Search';
breadcrumbNameMap[RootPath+'compute']= 'Computation';
breadcrumbNameMap[RootPath+'about']= 'About';
breadcrumbNameMap[RootPath+'news']= 'News';
breadcrumbNameMap[RootPath+'404']= 'Page not found';
breadcrumbNameMap[RootPath+'']= 'CASTpFold';

const MyBreadCrumb = ({ pathname }) => {
    //const snippets = [pathname.slice(0, 1)]
    const snippets = [pathname.slice(0, RootPath.length)]
    if (pathname.length > RootPath.length) {
        snippets.push(pathname);
    }
    const crumbs = snippets.map((snip) => (
        <Breadcrumb.Item key={snip}>
            <Link to={snip}>
                {breadcrumbNameMap[snip]}
            </Link>
        </Breadcrumb.Item>
    ))

    return (
        <Breadcrumb>
            {crumbs}
        </Breadcrumb>
    );
}

const CitationToConnect = ({ pathname }) => {
    const msg = (
        <div>
            {/* Your citation is really important to us. Please cite this paper if you publish or present results using CASTpFold analysis: */}
            <center><strong> <cite>CASTpFold: computed atlas of surface topography of protein fold universe.</cite> </strong></center>
            <strong>
            <center>Bowei Ye, Wei Tian, Boshen Wang, Jie Liang. <br/></center>
            
                {/* Nucleic Acids Res. 46(W1): W363–W367, 2018.  */}
            {/* PMID: <a target='_blank' rel="noopener noreferrer" href="https://www.ncbi.nlm.nih.gov/pubmed/29860391">29860391</a> DOI: <a target='_blank' rel="noopener noreferrer" href="https://doi.org/10.1093/nar/gky473">10.1093/nar/gky473</a>.</center> */}
            </strong>
        </div>
    );
    const msg2 = (
        <div>
            <center><strong> The CASTpFold server is free and open to all users, and there is no login requirement. </strong></center>
            {/* Your citation is really important to us. Please cite this paper if you publish or present results using CASTpFold analysis: */}
            <center><strong> <cite>CASTpFold: computed atlas of surface topography of protein fold universe.</cite> </strong></center>
            <strong>
            <center>Bowei Ye, Wei Tian, Boshen Wang, Jie Liang. <br/></center>
            
                {/* Nucleic Acids Res. 46(W1): W363–W367, 2018.  */}
            {/* PMID: <a target='_blank' rel="noopener noreferrer" href="https://www.ncbi.nlm.nih.gov/pubmed/29860391">29860391</a> DOI: <a target='_blank' rel="noopener noreferrer" href="https://doi.org/10.1093/nar/gky473">10.1093/nar/gky473</a>.</center> */}
            </strong>
        </div>
    );

    // Check if the pathname matches the landing page URL
    const isLandingPage = pathname === RootPath || pathname === RootPath.slice(0, -1);

    // Conditionally add the free access statement on the landing page
    if (isLandingPage) {
        return (
            <div>
                <Alert message={msg2} type="info" showIcon />
            </div>
        );
    } else {
        return (
                <Alert message={msg} type="info" showIcon />
                );
    }
}

//------------------- SubBanner --------------------
const SubBannerToConnect = ({ pathname }) => {
    
    if (pathname === RootPath || pathname === RootPath.slice(0,-1)) {
        return (<Row />)
    }
    else {
        return (
            <Row type='flex' justify='space-between' className="subbanner">
                {/* <Col><MyBreadCrumb pathname={pathname} /></Col> */}
                <Col>
                    <Breadcrumb separator='  '>
                        <Breadcrumb.Item><Link to={RootPath}>Home</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={RootPath+'compute'}>Compute</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={RootPath+'news'}>News</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={RootPath+'about'}>About</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col>
                    <SearchBox />
                </Col>
            </Row>
        )
    }
}
const mapStateToProps = state => ({
    pathname: state.router.location.pathname,
});
const SubBanner = connect(mapStateToProps)(SubBannerToConnect);
const Citation = connect(mapStateToProps)(CitationToConnect);



//------------------- BannerTitle --------------------

const BannerTitle = (
    <Link to={RootPath} className='bannerlink'>
        <Row type='flex' align='middle'>
            <Col>
                <img src={logo} alt="CASTpFold" style={{ 'height': '80px' }} />
            </Col>
            <Col span={1} />
            <Col>
                <div style={{ 'fontSize': '40px' }}>
                    CASTpFold
            </div>
                <div style={{ 'fontSize': '20px' }}>
                    <u>C</u>omputed <u>A</u>tlas of <u>S</u>urface <u>T</u>opography of <u>p</u>rotein <u>Fold</u> universe
            </div>
            </Col>
        </Row>
    </Link>
)



//------------------- real Banner --------------------

class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = { affixed: false }
    }
    render = () => {
        return (
            <Card bordered={false}>
                {BannerTitle}
                <Affix offsetTop={0}>
                    <SubBanner />
                </Affix>
                <br/>
                <Row type='flex' justify='center'>
                    <Col><Citation /></Col>
                </Row>
            </Card>
        );

    }
}


export default Banner;



// WEBPACK FOOTER //
// ./src/components/commons/Banner.js